import React from 'react';
import { trackLinksAndButtons } from './linksAndButtons';

export function trackEvent(label: string) {
    return function clickListener(e: React.UIEvent) {
        trackLinksAndButtons(label, e);
    };
}
